import { render, staticRenderFns } from "./newReport.vue?vue&type=template&id=146ab39e&scoped=true&"
import script from "./newReport.vue?vue&type=script&lang=js&"
export * from "./newReport.vue?vue&type=script&lang=js&"
import style0 from "./newReport.vue?vue&type=style&index=0&id=146ab39e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146ab39e",
  null
  
)

export default component.exports